import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIImage from 'UIComponents/image/UIImage';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeClientExamples({
  clientExamples,
  onTrackInteraction
}) {
  const {
    clientExampleClassName
  } = useResponsiveProps({
    clientExampleClassName: {
      xs: 'p-top-2',
      md: ''
    }
  });
  return /*#__PURE__*/_jsx(UIGrid, {
    children: clientExamples.map(({
      clientUrl,
      imageUrl
    }, index) => /*#__PURE__*/_jsx(UIGridItem, {
      className: clientExampleClassName,
      size: {
        xs: 12,
        md: 4
      },
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-hs-analytics-id": getThemeEventSelectorId('CLIENT-EXAMPLE'),
        external: true,
        href: clientUrl,
        iconProps: {
          className: 'hidden'
        },
        onClick: () => onTrackInteraction('click client example', {
          section: 'client examples',
          itemIndex: index
        }),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(UIImage, {
          alt: unescapedText('marketplace-assets-ui.themes.details.clientExamples.imageAlt', {
            index
          }),
          src: imageUrl
        })
      })
    }, `client-example-${index}`))
  });
}